<app-panorama-container
		*ngIf="selectedPanorama"
		[panoramic]="selectedPanorama.image"
		[panoramichotspots]="sitePanoramicHotspots"
		[haveLabels]="true"
		[showCompass]="showCompass"
		[guideAction]="actionGuide"
		[(rotateX)]="selectedPanorama.rotateX"
		[(rotateY)]="selectedPanorama.rotateY"
		[north_rotateY]="selectedPanorama.northRotateY"
		(panoramaConfigurationChange)="handleConfigurationChange($event)"
		[enableCaching]="true"
		[enableMouse]="isOwner"
		style=" position: absolute;width: 100%;"
		[style.height] = "panoramaHeight"
		></app-panorama-container>
<div class="monumentInformation {{monumentClass}}" *ngIf="isMonumentOpen" [class.disabled]="!isOwner">
	<div class="closeInfo" (click)="toggleMonument()" *ngIf="guiEnabled">
		<fa-icon [icon]="['fas','times']"></fa-icon>
	</div>
	<app-monument-detail *ngIf="selectedMonument" [guiEnabled]="guiEnabled" [(view)]="monumentView" (viewChange)="monumentViewChange.emit(this.monumentView)"
						 [monument]="selectedMonument"
						  [smallWindow]="true"></app-monument-detail>
</div>
<div class="monumentInformation fileShare" *ngIf="fileToShare" [class.disabled]="!isOwner">
	<div class="closeInfo" (click)="toggleFile()" *ngIf="guiEnabled">
		<fa-icon [icon]="['fas','times']"></fa-icon>
	</div>
	<img [src]="fileToShare" *ngIf="isImage(fileToShare)"/>
	<iframe [src]="transformPdf(fileToShare)" *ngIf="!isImage(fileToShare)" frameborder="0" style="height: 70vh;" width="100%">
	</iframe>
</div>